<template>
    <div id="app">
        <transition name="fade" mode="out-in">
            <app-layout v-if="layout === 'default-layout'"></app-layout>
            <auth-layout v-if="layout === 'auth-layout'"></auth-layout>
            <account-layout v-if="layout === 'account-layout'"></account-layout>
            <admin-layout v-if="layout === 'admin-layout'"></admin-layout>
            <payment-layout v-if="layout === 'payments-layout'"></payment-layout>
        </transition>
    </div>
</template>

<script>
    import AppLayout from "./views/template/layouts/AppLayout";
    import AuthLayout from './views/template/layouts/AuthLayout'
    import AccountLayout from "./views/template/layouts/AccountLayout";
    import PaymentLayout from "./views/template/layouts/PaymentLayout";
    import AdminLayout from "@/views/template/layouts/AdminLayout";

    const default_layout = "default";

    export default {
        components: {
            AppLayout,
            AuthLayout,
            AccountLayout,
            PaymentLayout,
            AdminLayout

        },
        data() {
            return {
                //isLoading: false,
            }
        },
        methods: {

        },
        computed: {

            layout() {
                return (this.$route.meta.layout || default_layout) + '-layout';
            }
        },
        mounted() {


            //console.log(this.$ref ? 'Axios works!' : 'Uh oh..');
        },
        created() {
        }
    }
</script>


<style>

    @import "assets/lib/@fortawesome/fontawesome-free/css/all.min.css";
    @import "assets/lib/ionicons/css/ionicons.min.css";
    @import "assets/lib/jqvmap/jqvmap.min.css";
    @import "assets/css/dashforge.css";
    @import "assets/css/dashforge.dashboard.css";
    @import "assets/css/dashforge.mail.css";
    @import "assets/css/dashforge.contacts.css";
    @import "assets/lib/typicons.font/typicons.css";
    @import "assets/lib/prismjs/themes/prism-vs.css";
    @import "assets/css/dashforge.filemgr.css";
    @import "assets/lib/datatables.net-dt/css/jquery.dataTables.min.css";
    @import "assets/lib/datatables.net-responsive-dt/css/responsive.dataTables.min.css";
    @import "assets/lib/select2/css/select2.min.css";
    @import "assets/css/pretty-checkbox.min.css";
    @import "assets/css/dashforge.chat.css";

</style>

